'use client';

import { AssetsSearch } from '@/app/assets/components/search/AssetsSearch';
import { Button, Group } from '@mantine/core';
import IconUpload from '@/icons/upload.svg';
import { useUploadAssets } from '@/app/assets/contexts/UploadAssetsContext';

export function AssetsPageHeader() {
  const { open } = useUploadAssets();
  return (
    <Group justify='space-between' gap='xs' px='xs'>
      <AssetsSearch />
      <Button
        className='self-end'
        variant='default'
        onClick={open}
        maw={150}
        leftSection={<IconUpload />}
        id='upload-button'
      >
        Upload Files
      </Button>
    </Group>
  );
}
